// extracted by mini-css-extract-plugin
export default {"detail_box":"Detail_detail_box__PPmtg","back":"Detail_back__QSQVi","title":"Detail_title__tQ2k+","time":"Detail_time__LGz0N","contain":"Detail_contain__2kjRd"};